export default __webpack_public_path__ + "static/media/pepperoni.ee2ae39e.png";